import React, { useState, useEffect } from "react";
import { NavLink, useHistory } from "react-router-dom";

// get our fontawesome imports
import {
  faChartLine,
  faPencilAlt,
  faChartPie,
  faUserFriends,
  faTruck,
  faUserTie,
  faBars,
  faTimes,
  faCog,
  faRobot,
  faCoins,
  faExclamationCircle,
  faCreditCard,
  faChartBar,
  faGift,
  faShoppingBasket,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { checkRole } from "../../utils/role";
import { API, Auth } from "aws-amplify";
import { useContext } from "react";
import { TabSideBarContext } from "../../context/TabSidebarContext";
import classNames from "classnames";

const CoundLoanPending = () => {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loanPendingCount();
  }, []);

  const loanPendingCount = async () => {
    try {
      setLoading(true);
      const response = await API.get("MoneyHubAdmin", "/loan/statusCount", {
        queryStringParameters: {},
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      setCount(response.Count);
    } catch (error) {
      console.log("ERROR", error);
    } finally {
      setLoading(false);
    }
  };

  if (count > 0 && !loading) {
    return (
      <span className="ml-2 text-white bg-red-500 rounded-full px-2 py-1 text-sm items-center flex">
        {count}
      </span>
    );
  }

  return null;
};

const Tab = ({ isActive, tabName, tabValue }) => {
  const { setTabSidebar } = useContext(TabSideBarContext);
  const { user } = useSelector((state) => state.initializeApp);
  const router = useHistory();

  const onChangeTabSidebar = () => {
    setTabSidebar(tabValue);
    localStorage.setItem("tabSidebar", tabValue);
    if (tabValue === "P") {
      router.push("/");
    } else {
      if (
        checkRole(user.groups, [
          "SuperAdmin",
          "Marketing",
          "Analyze",
          "AnalyzeApprove",
          "ApproveStaff",
          "ApproveSupervisor",
          "BusinessDevelopment",
          "CustomerService",
          "Admin",
        ])
      ) {
        router.push("/leasingDashboard");
      } else {
        router.push("/leasingRequest");
      }
    }
  };

  return (
    <div
      onClick={onChangeTabSidebar}
      className={classNames(
        "text-center text-sm py-2 hover:bg-gray-100 duration-300 transition-colors cursor-pointer",
        {
          "border-b-2 border-blue-500": isActive,
        }
      )}
    >
      {tabName}
    </div>
  );
};

export default function Sidebar({ setShowSidebar, showSidebar }) {
  const [collapseShow, setCollapseShow] = useState("hidden");

  const { user } = useSelector((state) => state.initializeApp);
  const { tabSidebar } = useContext(TabSideBarContext);
  const history = useHistory();

  const getNavLink = ({ Count, ...props }) => {
    return (
      <li className=" items-center">
        <NavLink
          {...props}
          activeStyle={{
            color: "rgba(59, 130, 246, 1)",
          }}
          activeClassName="border-l-4 border-indigo-300"
          className={
            " text-bas  py-3 font-medium block duration-300 transition-all " +
            "text-blueGray-700 hover:text-blueGray-500"
          }
        >
          <div className="flex px-6">
            <span className="mr-6">{props.icon}</span>
            <span className="text-left">{props.text}</span>
            {/* {Count !== undefined && <Count />} */}
          </div>
        </NavLink>
      </li>
    );
  };

  if (history.location.pathname.search("/contactBook") !== -1) {
    return null;
  }

  if (!showSidebar)
    return (
      <div
        className="fixed top-0 left-0  text-white z-20 p-3"
        onClick={() => setShowSidebar(true)}
      >
        <FontAwesomeIcon icon={faBars} className="text-2xl" />
      </div>
    );

  return (
    <>
      <nav className="md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative md:w-64 z-10 py-4">
        <div className="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">
          {/* Toggler */}
          {/* Brand */}
          <a
            href="/"
            className="mx-6 text-left md:pb-2 text-blueGray-600 mr-0  whitespace-nowrap text-sm uppercase font-bold p-4 px-0 flex flex-row items-center"
          >
            <img src="/icon.png" className="w-14 h-14 mr-4"></img>
            <div className="text-xl"> Money Hub</div>
          </a>

          <button
            className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
            type="button"
            onClick={() => setCollapseShow("bg-white m-2 py-3 px-6")}
          >
            <FontAwesomeIcon icon={faBars} />
          </button>
          {/* User */}

          {/* Collapse */}
          <div
            className={
              "md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded " +
              collapseShow
            }
          >
            {/* Collapse header */}
            <div className="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-blueGray-200">
              <div className="flex flex-wrap">
                <div className="w-6/12">
                  <a
                    href="/"
                    className="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
                  >
                    Money Hub
                  </a>
                </div>
                <div className="w-6/12 flex justify-end">
                  <button
                    type="button"
                    className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                    onClick={() => setCollapseShow("hidden")}
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </button>
                </div>
              </div>
            </div>
            {/* Form */}
            {/*
            <form className="mt-6 mb-4 md:hidden">
              <div className="mb-3 pt-0">
                <input
                  type="text"
                  placeholder="Search"
                  className="border-0 px-3 py-2 h-12 border border-solid  border-blueGray-500 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-base leading-snug shadow-none outline-none focus:outline-none w-full font-normal"
                />
              </div>
                          <hr className="my-4 md:min-w-full" />

            </form> */}

            {/* Divider */}

            <ul
              className="md:flex-col md:min-w-full flex flex-col list-none"
              onClick={() => setCollapseShow("hidden")}
            >
              <div className="grid grid-cols-2 mb-4 px-2 gap-1">
                <Tab
                  tabName={"Persernal Loan"}
                  isActive={tabSidebar === "P"}
                  tabValue={"P"}
                />
                <Tab
                  tabName={"Leasing"}
                  isActive={tabSidebar === "L"}
                  tabValue={"L"}
                />
              </div>

              {tabSidebar === "P" && (
                <React.Fragment>
                  {checkRole(user.groups, [
                    "SuperAdmin",
                    "Analyze",
                    "AnalyzeApprove",
                    "Marketing",
                    "ApproveStaff",
                    "ApproveSupervisor",
                    "BusinessDevelopment",
                    "CustomerService",
                    "Admin",
                  ]) &&
                    getNavLink({
                      text: "Dashboard",
                      to: "/",
                      exact: true,
                      icon: <FontAwesomeIcon icon={faChartLine} />,
                    })}

                  {checkRole(user.groups, [
                    "SuperAdmin",
                    "Analyze",
                    "AnalyzeApprove",
                    "CustomerService",
                    "Admin",
                    "Debt",
                    "ApproveStaff",
                    "ApproveSupervisor",
                    "CollectionStaff",
                    "CollectionSupervisor",
                    "BusinessDevelopment",
                    "Litigation",
                    "Marketing",
                    "CustomerService",
                    "RefinanceStaff"
                  ]) &&
                    getNavLink({
                      text: "Loan Request",
                      to: "/loanRequest",
                      icon: <FontAwesomeIcon icon={faPencilAlt} />,
                    })}

                  {checkRole(user.groups, [
                    "SuperAdmin",
                    "CustomerService",
                    "Admin",
                    "Litigation",
                  ]) &&
                    getNavLink({
                      text: "Transfer Loan",
                      to: "/transferLoan",
                      icon: <FontAwesomeIcon icon={faTruck} />,
                    })}

                  {checkRole(user.groups, [
                    "SuperAdmin",
                    "CustomerService",
                    "Admin",
                    "Marketing",
                    "AnalyzeApprove",
                    "Debt",
                    "ApproveStaff",
                    "ApproveSupervisor",
                    "CollectionStaff",
                    "CollectionSupervisor",
                    "BusinessDevelopment",
                    "Litigation",
                    "RefinanceStaff"
                  ]) &&
                    getNavLink({
                      text: "Loan",
                      to: "/loan",
                      icon: <FontAwesomeIcon icon={faCoins} />,
                      Count: CoundLoanPending,
                    })}

                  {checkRole(user.groups, [
                    "SuperAdmin",
                    "CustomerService",
                    "Admin",
                    "BusinessDevelopment",
                  ]) &&
                    getNavLink({
                      text: "LoanSandbox (Test)",
                      to: "/LoanSandbox",
                      exact: true,
                      icon: <FontAwesomeIcon icon={faChartLine} />,
                    })}

                  {checkRole(user.groups, [
                    "SuperAdmin",
                    "BusinessDevelopment",
                    "CustomerService",
                    "Admin",
                  ]) &&
                    getNavLink({
                      text: "Import Accrued",
                      to: "/importAccrued",
                      icon: <FontAwesomeIcon icon={faUserFriends} />,
                    })}

                  {checkRole(user.groups, [
                    "SuperAdmin",
                    "CustomerService",
                    "Admin",
                    "Debt",
                  ]) &&
                    getNavLink({
                      text: "Credit Buro",
                      to: "/buro",
                      exact: true,
                      icon: <FontAwesomeIcon icon={faChartLine} />,
                    })}

                  {/* {checkRole(user.groups, ["SuperAdmin"]) &&
                    getNavLink({
                      text: "LoanSandbox (5)",
                      to: "/sandbox5",
                      exact: true,
                      icon: <FontAwesomeIcon icon={faChartLine} />,
                    })}

                  {checkRole(user.groups, ["SuperAdmin"]) &&
                    getNavLink({
                      text: "LoanSandbox (6)",
                      to: "/sandbox6",
                      exact: true,
                      icon: <FontAwesomeIcon icon={faChartLine} />,
                    })} */}

                  {/* {user?.username === "nantanon" ||
                (user?.username === "pichan" &&
                  getNavLink({
                    text: "InterfaceCreate",
                    to: "/interfaceCreate",
                    exact: true,
                    icon: <FontAwesomeIcon icon={faChartLine} />,
                  }))}

              {(user?.username === "nantanon" || user?.username === "pichan") &&
                getNavLink({
                  text: "Accrued Interest",
                  to: "/accruedInterest",
                  exact: true,
                  icon: <FontAwesomeIcon icon={faChartLine} />,
                })} */}

                  {checkRole(user.groups, ["SuperAdmin", "Marketing"]) &&
                    getNavLink({
                      text: "Gift",
                      to: "/gift",
                      icon: <FontAwesomeIcon icon={faGift} />,
                    })}

                  {checkRole(user.groups, [
                    "SuperAdmin",
                    "Marketing",
                    "CustomerService",
                    "Admin",
                  ]) &&
                    getNavLink({
                      text: "Gift Request",
                      to: "/giftRequest",
                      icon: <FontAwesomeIcon icon={faShoppingBasket} />,
                    })}

                  {checkRole(user.groups, [
                    "SuperAdmin",
                    "Marketing",
                    "Analyze",
                    "AnalyzeApprove",
                    "Debt",
                    "CustomerService",
                    "Admin",
                    "ApproveSupervisor",
                    "CollectionSupervisor",
                    "BusinessDevelopment",
                    "Litigation",
                  ]) &&
                    getNavLink({
                      text: "Report",
                      to: "/report",
                      icon: <FontAwesomeIcon icon={faChartBar} />,
                    })}

                  {checkRole(user.groups, [
                    "SuperAdmin",
                    "BusinessDevelopment",
                    "CustomerService",
                    "Admin",
                  ]) &&
                    getNavLink({
                      text: "Sap",
                      to: "/sap",
                      icon: <FontAwesomeIcon icon={faChartBar} />,
                    })}

                  {checkRole(user.groups, [
                    "SuperAdmin",
                    "Marketing",
                    "Debt",
                    "CustomerService",
                  ]) &&
                    getNavLink({
                      text: "BroadCast",
                      to: "/broadCast/normal",
                      icon: <FontAwesomeIcon icon={faUserTie} />,
                    })}

                  {checkRole(user.groups, [
                    "SuperAdmin",
                    "Marketing",
                    "Debt",
                    "CollectionStaff",
                    "CollectionSupervisor",
                    "CustomerService",
                    "Admin",
                  ]) &&
                    getNavLink({
                      text: "BroadCastDebtor",
                      to: "/broadCast/debtor",
                      icon: <FontAwesomeIcon icon={faUserTie} />,
                    })}

                  {checkRole(user.groups, [
                    "SuperAdmin",
                    "CustomerService",
                    "Admin",
                    "Marketing",
                  ]) &&
                    getNavLink({
                      text: "ChatBot",
                      to: "/chatBot",
                      icon: <FontAwesomeIcon icon={faRobot} />,
                    })}

                  {checkRole(user.groups, ["SuperAdmin"]) &&
                    getNavLink({
                      text: "Settings",
                      to: "/settings",
                      icon: <FontAwesomeIcon icon={faCog} />,
                    })}
                </React.Fragment>
              )}

              {tabSidebar === "L" && (
                <React.Fragment>
                  {checkRole(user.groups, [
                    "SuperAdmin",
                    "Marketing",
                    "Analyze",
                    "AnalyzeApprove",
                    "ApproveStaff",
                    "ApproveSupervisor",
                    "BusinessDevelopment",
                    "CustomerService",
                    "Admin",
                  ]) &&
                    getNavLink({
                      text: "Dashboard",
                      to: "/leasingDashboard",
                      exact: true,
                      icon: <FontAwesomeIcon icon={faChartLine} />,
                    })}

                  {checkRole(user.groups, [
                    "SuperAdmin",
                    "Analyze",
                    "AnalyzeApprove",
                    "CustomerService",
                    "Admin",
                    "Debt",
                    "ApproveStaff",
                    "ApproveSupervisor",
                    "CollectionStaff",
                    "CollectionSupervisor",
                    "BusinessDevelopment",
                    "Litigation",
                    "Marketing",
                    "CustomerService",
                  ]) &&
                    getNavLink({
                      text: "Leasing Request",
                      to: "/leasingRequest",
                      exact: true,
                      icon: <FontAwesomeIcon icon={faPencilAlt} />,
                    })}

                  {checkRole(user.groups, [
                    "SuperAdmin",
                    "CustomerService",
                    "Admin",
                    "Litigation",
                  ]) &&
                    getNavLink({
                      text: "Leasing Transfer Loan",
                      to: "/leasingTransferLoan",
                      icon: <FontAwesomeIcon icon={faTruck} />,
                    })}

                  {checkRole(user.groups, [
                    "SuperAdmin",
                    "CustomerService",
                    "Admin",
                    "Marketing",
                    "AnalyzeApprove",
                    "Analyze",
                    "Debt",
                    "ApproveStaff",
                    "ApproveSupervisor",
                    "CollectionStaff",
                    "CollectionSupervisor",
                    "BusinessDevelopment",
                    "Litigation",
                  ]) &&
                    getNavLink({
                      text: "Leasing Loan",
                      to: "/leasingLoan",
                      icon: <FontAwesomeIcon icon={faCoins} />,
                    })}

                  {checkRole(user.groups, [
                    "SuperAdmin",
                    "CustomerService",
                    "Admin",
                    "BusinessDevelopment",
                  ]) &&
                    getNavLink({
                      text: "Leasing Test (จำนำ)",
                      to: "/leasingSandbox/ntf",
                      exact: true,
                      icon: <FontAwesomeIcon icon={faCoins} />,
                    })}

                  {checkRole(user.groups, ["SuperAdmin"]) &&
                    getNavLink({
                      text: "Leasing Test (เช่าซื้อ)",
                      to: "/leasingSandbox/tf",
                      exact: true,
                      icon: <FontAwesomeIcon icon={faCoins} />,
                    })}

                  {checkRole(user.groups, [
                    "SuperAdmin",
                    "CustomerService",
                    "Admin",
                    "Debt",
                  ]) &&
                    getNavLink({
                      text: "Credit Buro",
                      to: "/leasingCreditBuro",
                      exact: true,
                      icon: <FontAwesomeIcon icon={faChartLine} />,
                    })}

                  {checkRole(user.groups, [
                    "SuperAdmin",
                    "Marketing",
                    "Analyze",
                    "AnalyzeApprove",
                    "Debt",
                    "CustomerService",
                    "Admin",
                    "ApproveSupervisor",
                    "CollectionSupervisor",
                    "BusinessDevelopment",
                    "Litigation",
                  ]) &&
                    getNavLink({
                      text: "Report",
                      to: "/leasingReport",
                      icon: <FontAwesomeIcon icon={faChartBar} />,
                    })}

                  {checkRole(user.groups, ["SuperAdmin"]) &&
                    getNavLink({
                      text: "Model",
                      to: "/model",
                      icon: <FontAwesomeIcon icon={faChartBar} />,
                    })}

                  {checkRole(user.groups, ["SuperAdmin"]) &&
                    getNavLink({
                      text: "Settings",
                      to: "/leasingSettings",
                      icon: <FontAwesomeIcon icon={faCog} />,
                    })}

                  {checkRole(user.groups, ["SuperAdmin"]) &&
                    getNavLink({
                      text: "Settings Group (จำนำ)",
                      to: "/leasingSettingsGroup/NTF",
                      icon: <FontAwesomeIcon icon={faCog} />,
                    })}
                  {checkRole(user.groups, ["SuperAdmin"]) &&
                    getNavLink({
                      text: "Settings Group (เช่าซื้อ)",
                      to: "/leasingSettingsGroup/TF",
                      icon: <FontAwesomeIcon icon={faCog} />,
                    })}
                </React.Fragment>
              )}

              <div className="border-b border-gray-200"></div>
              <button
                className="bg-blue-500 text-white round-xl p-2 my-4  mx-6"
                onClick={() => setShowSidebar(false)}
              >
                Hide
              </button>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
